import {Action} from '@ngrx/store';
import {EducationsDTO} from '@staff-app/models/educationDTO';

export enum EducationActionTypes {
  GetEducations = '[Education] Get Educations',
  GetEducationsSuccessful = '[Education] Get Educations Successful',
  SaveEducations = '[Education] Save Educations',
  SaveEducationsSuccessful = '[Education] Save Educations Successful',
  NavigateAway = '[Education] Navigate Away'
}

export class GetEducations implements Action {
  readonly type = EducationActionTypes.GetEducations;

  constructor(public payload: number) {}
}
export class GetEducationsSuccessful implements Action {
  readonly type = EducationActionTypes.GetEducationsSuccessful;

  constructor(public payload: EducationsDTO) {}
}

export class SaveEducations implements Action {
  readonly type = EducationActionTypes.SaveEducations;

  constructor(public payload: EducationsDTO, public isEditMode = false) {}
}
export class SaveEducationsSuccessful implements Action {
  readonly type = EducationActionTypes.SaveEducationsSuccessful;

  constructor(public payload: number[]) {}
}
export class NavigateAway implements Action {
  readonly type = EducationActionTypes.NavigateAway;

  constructor() {}
}
export type EducationActions =
  | GetEducations
  | GetEducationsSuccessful
  | SaveEducations
  | SaveEducationsSuccessful
  | NavigateAway;
